import { useMe } from '@scout/identity'
import { ProductIcon } from '@scout/ui/icons'
import { SidebarItem, sidebarActiveProps } from '@scout/ui/sidebar'
import { Link } from '@tanstack/react-router'

/**
 * The sidebar's way to what a buyer already has.
 *
 * Renders nothing for a visitor who is nobody, and nothing while that is still
 * being decided — on the same terms as the briefs link, and for a sharper
 * reason: what an organisation runs is the organisation's, so there is nothing
 * here for a browser that belongs to none.
 */
export function VendorsLink() {
  const who = useMe()

  if (!who.settled || who.person === null) return null

  return (
    <SidebarItem asChild>
      <Link to="/app/vendors" activeProps={sidebarActiveProps}>
        <ProductIcon />
        Vendors
      </Link>
    </SidebarItem>
  )
}
